import {
  PacketModule,
  createPacketServices
} from "./chunk-UY3FDG6J.mjs";
import "./chunk-FOHPRMQF.mjs";
export {
  PacketModule,
  createPacketServices
};
